var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-tooltip-btn',{attrs:{"icon":_vm.search ? '$close' : '$mdiMagnify',"path":"search"},on:{"click":function($event){_vm.search = !_vm.search}}})
}
var staticRenderFns = []

export { render, staticRenderFns }